"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var CheckedIcon = function CheckedIcon() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#clip0_4431_227415)"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    x: "5",
    y: "5",
    width: "14",
    height: "14",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M9.98437 17.0156L18.9844 8.01563L17.5781 6.5625L9.98437 14.1563L6.42187 10.5938L5.01562 12L9.98437 17.0156ZM18.9844 3C19.5469 3 20.0156 3.20313 20.3906 3.60938C20.7969 3.98438 21 4.45313 21 5.01563L21 18.9844C21 19.5469 20.7969 20.0313 20.3906 20.4375C20.0156 20.8125 19.5469 21 18.9844 21L5.01562 21C4.45312 21 3.96875 20.8125 3.5625 20.4375C3.1875 20.0313 3 19.5469 3 18.9844L3 5.01563C3 4.45313 3.1875 3.98438 3.5625 3.60938C3.96875 3.20313 4.45312 3 5.01562 3L18.9844 3Z",
    fill: "#13131C"
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "clip0_4431_227415"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    width: "24",
    height: "24",
    fill: "white"
  }))));
};
var _default = CheckedIcon;
exports.default = _default;